<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TU0kXP/tc-custom/9781468303919.jpg?1720033646864" alt="This image is the cover for the book Circles Around the Sun"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Circles Around the Sun
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An author attempts to uncover who her older brother was before schizophrenia took hold of him in this “clear-eyed and heartbreaking” memoir (Publishers Weekly).</b><br/><br/> Molly McClosky’s brother Mike was fourteen when she was born. So far apart in age, she barely knew him before schizophrenia took hold of him at the age of twenty-three. Within a few years, Mike’s world began to fall apart. By the time Molly was old enough to begin to know him, Mike was heavily medicated and frequently delusional, living in hospitals or care homes or on the road.<br/><br/> Years later, through reading an astonishing archive of letters preserved by her mother and grandmother, and interviewing old friends of Mike's, Molly began to piece together a picture of her brother's life, before and after the illness struck—the story of how a gifted and well-liked student and athlete was overtaken by a terrible illness that rendered him unrecognizable. Now she tells that story, which is also the story of her own demons and of the ways in which a seemingly perfect family can slowly fall apart, and in the end, regroup. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Molly McCloskey
      </h2>
      
      <p class="authorDescription body article">Molly McCloskey grew up in Oregon. She is the author of a collection of short stories, Solomon's Seal; a novella and four short stories, The Beautiful Changes; and a novel, Protection.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?511bf6e1